document.addEventListener("DOMContentLoaded", () => {
  const btn = document.getElementById("bundle-add-to-cart");
  const status = document.getElementById("bundle-status");

  // --- Dynamische Preisaktualisierung (nur wenn Metafield custom.bundle_rabatt gesetzt ist) ---
  const bundleRoot = document.getElementById("bundle-root");
  const rawDiscount = bundleRoot?.dataset?.discountPercent;

  const hasMetafieldDiscount =
    rawDiscount !== undefined &&
    rawDiscount !== null &&
    String(rawDiscount).trim() !== "";

  if (hasMetafieldDiscount) {
    // Ganzzahlen (z.B. 12) funktionieren direkt; Komma wird sicherheitshalber unterstützt
    const discountPercent = parseFloat(String(rawDiscount).replace(",", "."));

    const sumEl = document.getElementById("bundle-sum");
    const savingEl = document.getElementById("bundle-saving");
    const savingRowEl = document.getElementById("bundle-saving-row");
    const totalEl = document.getElementById("bundle-total");

    const formatMoney = (cents) => {
      if (window.Shopify?.formatMoney) {
        const fmt =
          window.Shopify.money_format || "€{{amount_with_comma_separator}}";
        return window.Shopify.formatMoney(cents, fmt);
      }
      return (cents / 100).toLocaleString("de-DE", {
        style: "currency",
        currency: "EUR",
      });
    };

    const getLinePriceCents = (el) => {
      if (!el) return 0;

      // SELECT -> Preis aus selected option data-price
      if (el.tagName === "SELECT") {
        const opt = el.selectedOptions && el.selectedOptions[0];
        const v = opt && opt.dataset && opt.dataset.price;
        return v ? Number(v) : 0;
      }

      // hidden input -> Preis aus data-price
      const v = el.dataset && el.dataset.price;
      return v ? Number(v) : 0;
    };

    // Variante B: Bild-Link zeigt auf aktuell gewählte Variante
    const updateVariantLink = (el) => {
      const item = el.closest("[data-bundle-item]");
      if (!item) return;

      const link = item.querySelector("a.bundle-item-link");
      if (!link) return;

      const base = link.dataset.baseUrl || link.href.split("?")[0];
      link.href = `${base}?variant=${el.value}`;
    };

    const recalcBundlePrices = () => {
      if (!Number.isFinite(discountPercent)) return;

      const variantSelectors = document.querySelectorAll(".bundle-variant");
      let sum = 0;

      variantSelectors.forEach((el) => {
        sum += getLinePriceCents(el);
      });

      const discounted = Math.round((sum * (100 - discountPercent)) / 100);
      const saving = Math.max(0, sum - discounted);

      if (sumEl) sumEl.textContent = formatMoney(sum);
      if (totalEl) totalEl.textContent = formatMoney(discounted);

      if (savingEl) savingEl.textContent = `- ${formatMoney(saving)}`;
      if (savingRowEl) savingRowEl.style.display = saving > 0 ? "" : "none";
    };

    // Listener: Preise + Variant-Link updaten
    document.querySelectorAll(".bundle-variant").forEach((el) => {
      el.addEventListener("change", () => {
        recalcBundlePrices();
        if (el.tagName === "SELECT") updateVariantLink(el);
      });
    });

    // Initial: Preise + Links setzen
    recalcBundlePrices();
    document.querySelectorAll(".bundle-variant").forEach((el) => {
      if (el.tagName === "SELECT") updateVariantLink(el);
    });
  }

  // --- Add to cart (wie bisher) ---
  if (btn) {
    btn.addEventListener("click", async () => {
      if (status) status.innerText = "Bundle wird hinzugefügt ...";

      const variantSelectors = document.querySelectorAll(".bundle-variant");
      const items = [];

      variantSelectors.forEach((sel) => {
        items.push({
          id: sel.value,
          quantity: 1,
          properties: {
            _bundle: "1",
          },
        });
      });

      try {
        const response = await fetch("/cart/add.js", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ items }),
        });

        if (!response.ok) {
          if (status) status.innerText = "Fehler beim Hinzufügen.";
          return;
        }

        if (status) status.innerText = "Bundle wurde zum Warenkorb hinzugefügt!";
        window.location.href = "/cart";
      } catch (err) {
        if (status) status.innerText = "Unerwarteter Fehler.";
      }
    });
  }
});
